import React, { useMemo } from "react";
import runeTipsData from "./rune-tips.js";
import { useGenerateParsedText } from "./rune-guide-helpers";

const StatShardOverview = (props) => {
  const { seoNames, activeShards, championId, oppChampionId, role } = props;
  const generateParsedText = useGenerateParsedText();

  const getTipItems = () => {
    const rolePosition = role === "jungle" ? "jungle" : "lane";
    return activeShards.map((shardId, index) => {
      const text = generateParsedText(runeTipsData["statShards"][index][shardId][rolePosition]["text"], { seoNames, role });
      return (
        <div key={index} className="tip-item tip-item_list-item">
          <span className="item-number">{`${index + 1}. `}</span>
          <span>{text}</span>
        </div>
      );
    });
  };

  const shardOverviewText = `Take [shard_${activeShards[0]}_1], [shard_${activeShards[1]}_2], and [shard_${activeShards[2]}_3] on [champion] [role] vs [oppChampion]. Shards should be based on matchup.`;
  const parseTextProps = {
    seoNames,
    role,
    displayShardRowText: true,
    oppChampionId,
  };

  return (
    <div className="shard-overview">
      <div className="content-section_header">
        <strong>Stat Shards</strong>
      </div>
      <div>
        <div className="tip-item">{generateParsedText(shardOverviewText, parseTextProps)}</div>
        {getTipItems()}
      </div>
    </div>
  );
};

export default StatShardOverview;
